import React, { createContext, useState, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(() => {
        // Intenta recuperar el tema guardado en localStorage
        const savedTheme = localStorage.getItem('theme');
        return savedTheme || 'light'; // Por defecto, tema claro
    });

    // Cada vez que el tema cambia, actualiza el localStorage y aplica la clase al body
    useEffect(() => {
        localStorage.setItem('theme', theme);

        // Aplica o elimina la clase del body según el tema seleccionado
        if (theme === 'light') {
            document.body.classList.add('light-theme');
        } else {
            document.body.classList.remove('light-theme');
        }
    }, [theme]);

    const toggleTheme = () => {
        setTheme(prevTheme => prevTheme === 'dark' ? 'light' : 'dark');
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme debe ser usado dentro de un ThemeProvider');
    }
    return context;
};
